export default "__VITE_ASSET__Ch8YS4fW__"